const typeToName = {
  _nullStr:'',
  //是否 1 0
  yesNo(type){
    let str = this._nullStr;
    if(type == '1'){
      str = '是'
    }else{
      str = '否'
    }
    return str
  },
  //是否评审
  isReview(type){
    let str = this._nullStr;
    if(type == '1'){
      str = '已评审'
    }else{
      str = '待评审'
    }
    return str
  },
  //评审结果
  reviewResutl(type){
    let str = this._nullStr;
    if(type == '1'){
      str = '接受'
    }else if(type == '2'){
      str = '待定'
    }else if(type == '3'){
      str = '拒绝'
    }
    return str
  },
  //获取国家文字
  getCountryName(type){
    let res = '';//中国
    if(localStorage.getItem('AreaCountry')){
      let AreaCountry = JSON.parse(localStorage.getItem('AreaCountry'));
      AreaCountry.some((x)=>{
        if(x.id == type){
          res = x.areaCountry;
          return true;
        }
      })
    }
    return res;
  },
  //获取语言
  getLanguageName(type){
    let res = '';//中文
    if(type == 1){
      res = '英文'
    }else if(type == 2){
      res = '中文'
    }
    return res;
  }
}
export default typeToName;
